import { GenericClass } from './genericClass';

export class ReferenceDocument extends GenericClass {
    code: string;
}
